export const containerStyle = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flex: '1',
  height: '100%',
};

export const iframeStyle = {
  flex: 1,
  height: '100%',
};

export const MICRO_APP_URL = 'http://localhost:3002';

export const MICRO_APP_STARTUP_MESSAGE = 'initializeApp';
